export default {
  type: 'code',
  tagName: 'code'
}
